module.exports = __webpack_public_path__ + "img/speed-test.78d11282.svg";